<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M13,7.999999940395355C12.7,7.999999940395355,12.5,8.099999940395355,12.3,8.299999940395356C12.3,8.299999940395356,9,11.599999940395355,9,11.599999940395355C9,11.599999940395355,9,1.9999999403953552,9,1.9999999403953552C9,1.4999999403953552,8.6,0.9999999403953552,8,0.9999999403953552C7.4,0.9999999403953552,7,1.4999999403953552,7,1.9999999403953552C7,1.9999999403953552,7,11.599999940395355,7,11.599999940395355C7,11.599999940395355,3.7,8.299999940395356,3.7,8.299999940395356C3.5,8.099999940395355,3.3,7.999999940395355,3,7.999999940395355C2.5,7.999999940395355,2,8.499999940395355,2,8.999999940395355C2,9.299999940395356,2.1,9.499999940395355,2.3,9.699999940395355C2.3,9.699999940395355,7.3,14.699999940395355,7.3,14.699999940395355C7.5,14.899999940395356,7.7,14.999999940395355,8,14.999999940395355C8.3,14.999999940395355,8.5,14.899999940395356,8.7,14.699999940395355C8.7,14.699999940395355,13.7,9.699999940395355,13.7,9.699999940395355C13.9,9.499999940395355,14,9.299999940395356,14,8.999999940395355C14,8.399999940395356,13.6,7.999999940395355,13,7.999999940395355C13,7.999999940395355,13,7.999999940395355,13,7.999999940395355C13,7.999999940395355,13,7.999999940395355,13,7.999999940395355Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'ArrowDown',
} as DefineComponent
</script>
